/**
 * Error codes for Hogeschooltaal - Content API
 */
module.exports = {
  EXPIRED_PRODUCT_LICENSE: 'E-HST-CNT-EXPLC',
  NOT_OWNED_PRODUCT: 'E-HST-CNT-NOWPR',
  NOT_OWNED_SCHEDULED_TEST: 'E-HST-CNT-NOWST',
  OUT_OF_BOUNDS_SCHEDULED_TEST: 'E-HST-OOBST',
  ONGOING_SCHEDULED_TEST: 'E-HST-CNT-ONGST',
  TEST_ACCESS_PASSWORD_REQUIRED: 'E-HST-CNT-TAPRQ',
  TEST_REVIEW_ACCESS_PASSWORD_REQUIRED: 'E-HST-CNT-TRAPRQ',
  INVALID_TEST_SESSION_TOKEN: 'E-HST-CNT-IVTST',
  MIXED_EXERCISE_NOT_UNLOCKED: 'E-HST-CNT-MIXLK',
  ENDED_SCHEDULED_TEST: 'E-HST-CNT-ENDST',
  SCHOOLYEAR_ACCESS_REQUIRED: 'E-HST-CNT-SYARQ',
  MISSING_SCHOOLYEAR_API_KEY: 'E-HST-CNT-NOSYAK',
};
